import React, { Component } from 'react';
import "./partners.css";
import _ from "lodash";

class Partners extends Component {
    renderPartners(partners){
        return _.map( partners, partner => {
            return (
                <div key={partner.id} className={`partner-content-item ${this.props.visible ? "animated fadeInUp" : "opa-0"}`}>
                    <img src={partner.img.src} alt={partner.img.alt} />
                </div>
            )
        });
    }

    render() {
        return (
            <div className="partners">
                <div className="partners-content">
                    {this.renderPartners(this.props.content)}
                </div>
            </div>
        );
    }
}

export default Partners;


// WEBPACK FOOTER //
// ./src/sections/Partners.js